import { render } from "./AiEmailTemplate.vue?vue&type=template&id=bbe2828e"
import script from "./AiEmailTemplate.vue?vue&type=script&lang=js"
export * from "./AiEmailTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiEmailTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbe2828e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbe2828e', __exports__)) {
    api.reload('bbe2828e', __exports__)
  }
  
  module.hot.accept("./AiEmailTemplate.vue?vue&type=template&id=bbe2828e", () => {
    api.rerender('bbe2828e', render)
  })

}


export default __exports__